// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__39WZs","file":"styles_file__206Ni"};